import { render, staticRenderFns } from "./UiHexagon.vue?vue&type=template&id=5f3f745e&scoped=true&"
import script from "./UiHexagon.vue?vue&type=script&lang=ts&"
export * from "./UiHexagon.vue?vue&type=script&lang=ts&"
import style0 from "./UiHexagon.vue?vue&type=style&index=0&id=5f3f745e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f745e",
  null
  
)

export default component.exports